// Based on https://engineering.classdojo.com/blog/2016/12/10/catching-react-errors/
import ReactUpdates from "react-dom/lib/ReactUpdates";
import ReactDefaultBatchingStrategy from "react-dom/lib/ReactDefaultBatchingStrategy";

import store from "app/store";
import { createAlert } from "modules/app/actions";
import logError from "lib/utils/errors/logError";

if (!__DEV__) {
  let isHandlingError = false;
  const ReactTryCatchBatchingStrategy = {
    // this is part of the BatchingStrategy API. simply pass along
    // what the default batching strategy would do.
    get isBatchingUpdates() {
      return ReactDefaultBatchingStrategy.isBatchingUpdates;
    },

    batchedUpdates(...args) {
      try {
        ReactDefaultBatchingStrategy.batchedUpdates(...args);
      } catch (e) {
        if (isHandlingError) {
          // our error handling code threw an error. just throw now
          throw e;
        }

        isHandlingError = true;
        try {
          const errorId = logError(e);
          store.dispatch(
            createAlert({
              type: "error",
              uuid: "APP_ERROR",
              content: `Wystąpił błąd aplikacji` + (errorId ? ` nr ${errorId}` : ""),
              timeout: false,
            })
          );
        } finally {
          isHandlingError = false;
        }
      }
    },
  };

  ReactUpdates.injection.injectBatchingStrategy(ReactTryCatchBatchingStrategy);
}



// WEBPACK FOOTER //
// ./src/app/initializers/errorHandling.js